import { selector } from '../../helper/index';
const thank_you = {
    namespace: "thank_you",
    afterEnter(data) {
        console.log(`enter ${this.namespace}`);
        
        // let thankYouWrapClone = $('.thank-you-wrap').clone();
        // let thankYouSelector = selector(thankYouWrapClone);
        // // gsap.set(thankYou, { autoAlpha: 0, y: 10 });
        // $('.thank-you-wrap').remove();

        // const showThankYouForm = () => {
        //     let tl = gsap.timeline();
        //     $('.main.thank-you').append(thankYouWrapClone);

        //     tl
        //     .from('.thank-you-bg', {
        //         autoAlpha: 0.5, duration: 2
        //     })
        //     .from(thankYouSelector('.thank-you-popup'), {
        //         autoAlpha: 0, y: 15, ease: 'power1.out', duration: 1
        //     }, 0).from(thankYouSelector('.thank-you-thanks'), {
        //         autoAlpha: 0, y: 15, ease: 'power1.out', duration: .8
        //     }, ">=-0.6")
        //     .from(thankYouSelector('.thank-you-back'), {
        //         autoAlpha: 0, y: 15, ease: 'power1.out', duration: .8
        //     }, ">=-0.6")
        //     .from(thankYouSelector('.thank-you-contact'), {
        //         autoAlpha: 0, ease: 'power1.out', duration: 1
        //     }, ">=-0.5")
        // }
        // function thankYouMain() {
        //     showThankYouForm();
        // }
        // thankYouMain();
    },
    beforeLeave(data) {
        console.log(`leave ${this.namespace}`);
    }
}

export default thank_you;
